import { memo } from 'react';

import { ChoiceType } from '../../data';
import { ChoiceButton, ChoicesContainer } from './SingleChoice.styled';

export const SingleChoice = memo<ChoiceType>((props) => {
  const { options, sendMessage, disabled } = props;

  return (
    <ChoicesContainer>
      {options.map((val) => (
        <ChoiceButton key={val} disabled={disabled} onClick={() => sendMessage(val, [val])}>
          {val}
        </ChoiceButton>
      ))}
    </ChoicesContainer>
  );
});

SingleChoice.displayName = 'SingleChoice';
